import { Dispatch } from 'redux';
import { ConfigurationActions } from '../store/ConfigurationSlice';
import { NotificationActions } from '../store/NotificationSlice';

export const getApiUrl = (basePath: string) => {
    return async (dispatch: Dispatch) => {
        const fetchData = async () => {
            const response = await fetch(basePath + '/api/Configuration/getapiurl');

            if (!response.ok) {
                throw new Error('Could not fetch Api Configuration data!');
            }

            const data = await response.json();
            return data;
        };

        try {
            const configData = await fetchData();
            dispatch(ConfigurationActions.setApiUrl({ apiUrl: configData }));
        }
        catch (error) {
            dispatch(NotificationActions.showNotification({status:'error',title:'Error!',message:'Fetching Api Configuration failed!'}));
        }
    };
};

export default getApiUrl;